import React from "react";
import PropTypes from "prop-types";
import { Container, Row, Col } from "react-bootstrap";
import { MDBBtn, MDBBtnGroup } from "mdbreact";
import { Link } from "gatsby";

import { GGgetMode } from "../../services/gglocalstorage";
import BotaoIngressoCurso from "../BotaoIngressoCurso/BotaoIngressoCurso";
import "./TopoCurso.css";

export default function TopoCurso({
	curso,
	cursoSelecionado,
	selectedIndex,
	cursoEspecial = false,
	isMedicina = false,
}) {
	const proposito = cursoSelecionado?.Argumentos?.Proposito?.Value;
	const processo = cursoSelecionado?.Argumentos?.Processo?.Value;
	const resultado = cursoSelecionado?.Argumentos?.Resultado?.Value;

	const modalidadeAtual =
		cursoSelecionado?.Informacoes?.Modalidade?.Value;

	const tipoCurso = cursoSelecionado?.Informacoes?.Tipo?.Value;

	const valorPrimeiroAnoEAD =
		modalidadeAtual === "EAD"
			? [
					{ modalidade: "Licenciatura", valor: "R$ 299,90" },
					{ modalidade: "Tecnologo", valor: "R$ 299,90" },
					{ modalidade: "Bacharelado", valor: "R$ 299,90" },
			  ].find((item) => item.modalidade === tipoCurso)?.valor || "R$ 299,90"
			: null;

	const editalLink = cursoEspecial
		? "https://editais.feevale.br/editais/edital-reitoria-092026-processo-seletivo-complementar-programa-professor-do-amanha/"
		: isMedicina
		? "https://editais.feevale.br/editais/processo-seletivo-medicina-202701/"
		: modalidadeAtual === "EAD"
		? "https://editais.feevale.br/editais/processo-seletivo-feevale-ead-2026/"
		: ["Hibrido", "Semipresencial", "Presencial"].includes(modalidadeAtual)
		? "https://editais.feevale.br/editais/processo-seletivo-vestibular-para-cursos-presenciais-e-semipresenciais-202602/"
		: null;

	return (
		<Container>
			{cursoSelecionado?.Informacoes?.Aviso?.Value && (
				<Row>
					<Col>
						<div
							className={`text-center font-weight-bold bg-nowhite rounded p-3 mb-4 ${
								!GGgetMode() ? "text-white" : ""
							}`}
							dangerouslySetInnerHTML={{
								__html: cursoSelecionado.Informacoes.Aviso.Value,
							}}
						/>
					</Col>
				</Row>
			)}

			<Row
				className="curso-topo-conteudo-row text-center text-md-left"
				style={{ paddingTop: "30px" }}
			>
				<Col md="8" className="curso-topo-conteudo">
					<div className="curso-topo-cabecalho">
						<h1
							className={
								(GGgetMode() ? "text-white" : "text-secondary") +
								" font-weight-bold"
							}
						>
							{curso.Title}
						</h1>

						<MDBBtnGroup>
							<Row className="text-center justify-content-center">
								{curso.Opcoes != null &&
									curso.Opcoes.map((opcao, index) => {
										if (
											GGgetMode() &&
											curso.Items[index].Integracao.Ofertado.Value
										) {
											return null;
										}

										const isSelected =
											opcao === curso.Opcoes[selectedIndex];

										return (
											<Link key={opcao} to={`#${index}`}>
												<MDBBtn
													active={!isSelected}
													color="primary"
													width="100%"
													className="btnModalidades"
												>
													{opcao.includes("Híbrido")
														? opcao.replace("Híbrido", "Presencial")
														: opcao}
												</MDBBtn>
											</Link>
										);
									})}
							</Row>
						</MDBBtnGroup>
					</div>

					<div className="curso-topo-texto">
						{proposito && (
							<p
								className="text-black"
								dangerouslySetInnerHTML={{ __html: proposito }}
							/>
						)}

						{processo && (
							<p
								className="text-black"
								dangerouslySetInnerHTML={{ __html: processo }}
							/>
						)}

						{resultado && (
							<p
								className="text-black"
								dangerouslySetInnerHTML={{ __html: resultado }}
							/>
						)}
					</div>
				</Col>

				<Col md="4" className="curso-topo-acoes">
					<div className="curso-topo-acoes-conteudo">
						<BotaoIngressoCurso
							modalidade={modalidadeAtual}
							isMedicina={isMedicina}
							cursoEspecial={cursoEspecial}
						/>

						<div className="curso-topo-investimento-resumo">
							{modalidadeAtual === "EAD" ? (
								<>
									<span className="curso-topo-investimento-label">
										Mensalidade do 1º ano
									</span>

									<strong className="curso-topo-investimento-valor">
										{valorPrimeiroAnoEAD}
									</strong>

									<span className="curso-topo-investimento-complemento">
										por mês no 1º ano
									</span>

									<a
										className="curso-topo-investimento-botao"
										href="#investimento"
									>
										Ver investimento completo
									</a>
								</>
							) : (
								<>
									<strong className="curso-topo-investimento-titulo">
										Investimento
									</strong>

									<p className="curso-topo-investimento-texto">
										Confira os valores, condições e informações de pagamento
										deste curso.
									</p>

									<a
										className="curso-topo-investimento-botao"
										href="#investimento"
									>
										Ver investimento
									</a>
								</>
							)}
						</div>

						{editalLink && (
							<div className="curso-topo-edital">
								<a
									href={editalLink}
									target="_blank"
									rel="noopener noreferrer"
								>
									<MDBBtn className="btn-edital saira-title curso-topo-edital-btn">
										Edital
									</MDBBtn>
								</a>
							</div>
						)}
					</div>
				</Col>
			</Row>
		</Container>
	);
}

TopoCurso.propTypes = {
	curso: PropTypes.object.isRequired,
	cursoSelecionado: PropTypes.object.isRequired,
	selectedIndex: PropTypes.number.isRequired,
	cursoEspecial: PropTypes.bool,
	isMedicina: PropTypes.bool,
};
